import {z} from '@hono/zod-openapi';

import {priceReportArgumentCategorySchema} from './PriceReportArgumentCategorySchema';

export const priceReportArgumentSchema = z
  .object({
    title: z.string(),
    text: z.string(),
    category: priceReportArgumentCategorySchema,
    strength: z.enum(['strong', 'medium']),
    // data = backed by facts of this report, general = widely known knowledge about the model.
    source: z.enum(['data', 'general']),
    factIds: z.array(z.string()),
  })
  .openapi('PriceReportArgument');

export type PriceReportArgument = z.infer<typeof priceReportArgumentSchema>;
